export default __webpack_public_path__ + "static/media/948.3b2eeded.gif";